import { html } from "lit";
import { when } from "lit/directives/when.js";
import { tokenMap } from "../../../../common/utils";
import { DEFAULT_ASSISTANT_STATUS, getMessageContent } from "../../utils";
const defaultAssistantContentRender = (message, chatRef, codeBlockRender) => {
    const messageContent = getMessageContent(message);
    return message.status === "waiting"
        ? html `<div
        class="assistant-loading"
        part=${tokenMap({
            [`assistant content waiting ${message.id}`]: true,
            [message.parts]: !!message.parts
        })}
      >
        ${messageContent}
      </div>`
        : when(messageContent, () => html `<ch-markdown-viewer
          part=${tokenMap({
            [`assistant content ${message.id} ${message.status ?? DEFAULT_ASSISTANT_STATUS}`]: true,
            [message.parts]: !!message.parts
        })}
          .renderCode=${codeBlockRender(chatRef)}
          .showIndicator=${message.status === "streaming"}
          .theme=${chatRef.markdownTheme}
          .value=${messageContent}
        ></ch-markdown-viewer>`);
};
const defaultErrorContentRender = (message, chatRef, codeBlockRender) => {
    const errorContent = getMessageContent(message);
    return when(errorContent, () => html `<ch-markdown-viewer
        part=${tokenMap({
        [`error content ${message.id}`]: true,
        [message.parts]: !!message.parts
    })}
        .renderCode=${codeBlockRender(chatRef)}
        .theme=${chatRef.markdownTheme}
        .value=${errorContent}
      ></ch-markdown-viewer>`);
};
const defaultUserContentRender = (messageModel) => getMessageContent(messageModel);
const defaultSystemContentRender = () => null;
const contentRenderByRole = {
    assistant: defaultAssistantContentRender,
    error: defaultErrorContentRender,
    system: defaultSystemContentRender,
    user: defaultUserContentRender
};
export const defaultContentRender = (message, chatRef, codeBlockRender) => contentRenderByRole[message.role](message, chatRef, codeBlockRender);
